
import {
  clueSearchKeys,
  fetchClueDatas,
  finishFollow,
  finishSign,
  exportClueFields,
  repeatFollowClue,
  delClue,
  fetchFollowLog,
  getCluePermission
} from '@/services/clue'
import _ from 'lodash'
// import { isMobile } from '@/lib/device'
import { toType } from '@/lib/utils'
import i18n from '@/lib/language'
import { Message } from 'ant-design-vue'

const state = {
  loading: true,
  searched: false,
  permissions: null,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    pageSizes: ['10', '20', '30', '50'],
    total: 0
  },
  searchConfig: {
    key: '',
    value: '',
    options: [],
    placeholder: ''
  },
  isFollow: false,
  titles: [],
  list: [],
  followLogs: {},
  cluePremissionData: {}
}

const getters = {
  newList (state) {
    const { list } = state
    if (!list || !list.length) return

    let data = _.cloneDeep(list)
    data.forEach(item => {
      item.tempid = item.id
      // item.hover = false
      for (let k in item) {
        if (toType(item[k]) === 'object') {
        } else if (toType(item[k]) === 'string') {
          item[k] = item[k] || '- -'
        } else if (toType(item[k]) === 'array') {
          // if (k === 'children') {
          //   item[k].forEach(item2 => {
          //     item2['tempid'] = item2.id
          //     item2['code'] = item2.fieldname + item2.fieldvalue
          //     item2['id'] = item2.parentkey + item2.fieldkey + item2.id
          //     item2['dev_userid'] = item['dev_userid']
          //   })
          // } else {
          //   item[k] = item[k].join(',')
          // }
          // item[k].forEach(item2 => {
          //   for (let k2 in item2) {
          //     if (toType(item2[k2]) === 'object') {
          //     } else if (toType(item2[k2]) === 'string') {
          //       item2[k2] = item2[k2] || '- -'
          //     }
          //   }
          // })
        }
      }
    })
    return data
  },
  columns (state) {
    const { titles = {} } = state
    let newArr = []
    for (let fieldkey in titles) {
      const fieldTitle = titles[fieldkey]
      let field = {}

      field.dataIndex = fieldkey
      field.title = fieldTitle
      switch (fieldkey) {
        case 'code':
          field.width = 140
          break
        case 'from_info':
        case 'follow_num':
          field.width = 100
          break
        case 'follow_field':
        case 'contact_name':
          field.width = 120
          break
        case 'follow_date':
          field.width = 175
          break
        case 'clue_status':
          field.width = 115
          break
      }
      // field.width = tdWidth

      // if (fieldkey === 'contact_info_contact_mobile' || fieldkey === 'contact_info_contact_email') {
      //   field.width = 300
      // }
      // switch(field.fieldkey) {
      //   case ''
      // }

      // for (let item of list) {
      //   for (let k in item) {
      //     if (k === fieldkey && (toType(item[k]) === 'object' || toType(item[k].fieldvalue) === 'array')) {
      //       field.scopedSlots = { customRender: fieldkey }
      //     }
      //   }
      // }
      field.scopedSlots = { customRender: fieldkey }
      // field.scopedSlots = { customRender: fieldkey }
      newArr.push(field)
    }
    return [
      ...newArr,
      {
        title: '操作',
        key: 'operation',
        width: 100,
        scopedSlots: { customRender: 'action' }
      }
    ]
  }
}

const mutations = {
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_SEARCHED (state, data) {
    state.searched = data
  },
  SET_LIST_DATA (state, data) {
    state.list = data
  },
  SET_PERMISSIONS (state, data) {
    state.permissions = data
  },
  SET_TITLES (state, data) {
    state.titles = data
  },
  SET_TOTAL (state, data) {
    state.pagination.total = data
  },
  SET_SEARCH_CONFIG (state, data) {
    state.searchConfig = data
  },
  RESET_PAGINATION (state) {
    state.pagination = {
      currentPage: 1,
      pageSize: 10,
      pageSizes: ['10', '20', '30', '50'],
      total: 0
    }
  },
  setIsFollow (state, b) {
    state.isFollow = b
  },
  setFollowLogs (state, data) {
    state.followLogs = data
  },
  setClueMenu (state, data) {
    state.cluePremissionData = data
  }
}

const actions = {
  async fetchSearchConfig ({ state, commit }, data) {
    const chain = await clueSearchKeys().onSuccess(async payload => {
      payload.forEach(item => {
        if (item.parentkey) {
          item.fieldkey = item.parentkey + '.' + item.fieldkey
        }
      })
      state.searchConfig.options = payload

      if (payload.length) {
        state.searchConfig.key = payload[0].fieldkey
        state.searchConfig.value = ''
        state.searchConfig.placeholder = `${i18n.t('message["751"]')} ${payload[0].fieldname}`
      }
      commit('SET_SEARCH_CONFIG', state.searchConfig)
    })
    return chain
  },
  async setSearchConfig ({ state, commit }, searchConfig) {
    commit('SET_SEARCH_CONFIG', searchConfig)
  },
  clearList ({ state, commit }) {
    // commit('SET_LOADING', true)
    commit('SET_LIST_DATA', [])
    commit('SET_LOADING', true)
    commit('SET_SEARCHED', false)
  },
  async fetchClueDatas ({ state, commit }, data) {
    commit('SET_LIST_DATA', [])
    commit('SET_LOADING', true)
    const chain = await fetchClueDatas()
      .params(data)
      .onSuccess(async (payload, raw = {}) => {
        const { permissions = {} } = raw
        const { count = '', list = [], title = [] } = payload

        commit('SET_LOADING', false)
        commit('SET_LIST_DATA', list)
        commit('SET_TITLES', title)
        commit('SET_TOTAL', parseInt(count))
        commit('SET_PERMISSIONS', permissions)

        commit('SET_SEARCHED', true)
      })
      .onNetSuccess(raw => {
        commit('SET_LOADING', false)
      })
      .onFail(() => {
        commit('SET_LOADING', false)
      })
      .fetch()
    return chain
  },
  async finishFollow ({ commit, dispatch }, data) {
    const chain = await finishFollow()
    chain.onSuccess(raw => {
      dispatch('fetchClueDatas', data)
      Message.success('完成跟进成功', 2)
    })
    return chain
  },
  async finishSign ({ commit, dispatch }, data) {
    const chain = await finishSign()
    chain.onSuccess(raw => {
      if (!data.isdetail) {
        dispatch('fetchClueDatas', data)
      }
      Message.success('标记无效成功', 2)
    })
    return chain
  },
  async exportClueFields ({ commit, dispatch }, data) {
    const chain = await exportClueFields()
    chain.params(data)
      .onSuccess(raw => {
        // dispatch('fetchClueDatas')
        // Message.success('标记失效成功', 2)
      })
    return chain
  },
  async fetchFollowLog ({ commit }, data) {
    const chain = await fetchFollowLog()
    chain.params(data)
      .onSuccess(raw => {
        commit('setFollowLogs', raw)
      })
      .fetch()
    return chain
  },
  // 重新跟进
  async repeatFollowClue ({ commit, dispatch }, data) {
    const chain = await repeatFollowClue()
    chain.onSuccess(raw => {
      if (!data.isdetail) {
        dispatch('fetchClueDatas', data)
      }
      Message.success('操作成功', 2)
    })
    return chain
  },
  // 删除线索
  async delClue ({ commit, dispatch }, data) {
    const chain = await delClue()
    chain.onSuccess(raw => {
      dispatch('fetchClueDatas', data)
      Message.success('操作成功', 2)
    })
    return chain
  },
  // 列表线索权限
  async getCluePermission ({ commit, dispatch }, data) {
    const chain = await getCluePermission()
    chain.onSuccess(raw => {
      commit('setClueMenu', raw)
    })
      .fetch()
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
